import React, { Fragment } from 'react'
import {
  BaseForm,
  Upload,
  VALIDATION_TYPES,
  Select,
  Input,
  SingleDatePicker,
} from '../../../../components/Form'
import moment from 'moment'

import './style.css'

const timeOptions = (interval = 60) => {
  const times = []
  const x = {
    slotInterval: interval,
    openTime: '00:00',
    closeTime: '24:00',
  }
  let startDate = moment(x.openTime, 'HH:mm')
  const endDate = moment(x.closeTime, 'HH:mm')
  while (startDate < endDate) {
    times.push(startDate.format('HH:mm'))
    startDate = startDate.add(x.slotInterval, 'm')
  }
  return times
}
class SWABannerLabelsForm extends BaseForm {
  constructor(props) {
    super(props)
    /* istanbul ignore next */
    if (!this.props.value) {
      const value = this.state.values
      if (this.props.method === 'add') {
        value.banners = [{ link: '', bannerImage: '' }]
        value.startDate = moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        value.campaignStartTime = '05:00'
      }
    }

    this.handleBannerAdd = this.handleBannerAdd.bind(this)
  }

  componentDidMount() {
    /* istanbul ignore next */
    if (this.props.method === 'add') {
      this.setState({ loader: true })
    }
  }

  pickerEndDate() {
    const { endDate } = this.state.values
    const endDatePlaceholder = endDate && moment(endDate).format('HH:mm')

    const datePicker = {
      label: 'Valid To',
      placeholder: 'End Date',
      displayFormat: 'YYYY-MM-DD',
      openDirection: 'up',
      name: 'endDate',
      className: 'date-section',
    }

    const select = {
      label: 'End Time',
      name: 'campaignendDate',
      type: 'text',
      className: 'time-section',
      placeholder: endDatePlaceholder || '00:00',
      options: timeOptions(30),
    }

    return (
      <div className="form-section date-time-section">
        <SingleDatePicker
          {...datePicker}
          {...this.generateStateMappers({
            stateKeys: ['endDate'],
            validationType: VALIDATION_TYPES.ONSUBMIT,
            loseEmphasisOnFill: true,
          })}
        />
        <Select
          {...select}
          {...this.generateStateMappers({
            stateKeys: ['campaignEndTime'],
            validationType: VALIDATION_TYPES.ONSUBMIT,
            loseEmphasisOnFill: true,
          })}
        />
      </div>
    )
  }

  pickerStartDate() {
    const { startDate } = this.state.values
    const startDatePlaceholder = moment(startDate).format('HH:mm')
    return (
      <Fragment>
        <div className="form-section date-time-section">
          <SingleDatePicker
            label="Valid From"
            placeholder="Start Date"
            displayFormat="YYYY-MM-DD"
            name="startDate"
            className="date-section"
            allowToday
            enableToday
            required
            openDirection={'up'}
            {...this.generateStateMappers({
              stateKeys: ['startDate'],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
          />
          <Select
            label="Start Time"
            name="campaignstartDate"
            type="text"
            className="time-section"
            placeholder={startDatePlaceholder || '00:00'}
            options={timeOptions(30)}
            {...this.generateStateMappers({
              stateKeys: ['campaignStartTime'],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
          />
        </div>
        {this.pickerEndDate()}
      </Fragment>
    )
  }

  componentWillUnmount() {
    this.api && this.api.cancel()
  }

  linkUrl(index, item) {
    return (
      <div className="form-section block-section">
        <Input
          label="Link Url"
          placeholder="Please enter the url link with this banner"
          name={`name-${index}`}
          type="text"
          value={item.link}
          required
          {...this.generateStateMappers({
            stateKeys: [`name-${index}`],
            loseEmphasisOnFill: true,
          })}
        />
      </div>
    )
  }

  handleBannerAdd(e) {
    e.preventDefault()
    this.setState({
      values: {
        ...this.state.values,
        banners: [...this.state.values.banners, { link: '', bannerImage: '' }],
      },
    })
  }

  render() {
    const { Form } = this.components
    const { SubmitButton, CancelButton } = this.buttons
    return (
      <Form className="swa-banner-form" testid="search-campaigns-form">
        <fieldset>
          <div className="form-sections">
            {this.state.values.banners.map((item, index) => {
              return (
                <div className="banner_link" key={index}>
                  <div className="form-section cl-logo-upload">
                    <Upload
                      label="SWA Banner Image"
                      required
                      name={`logo-${index}`}
                      {...this.generateStateMappers({
                        stateKeys: [`logo-${index}`],
                        validationType: VALIDATION_TYPES.ONSUBMIT,
                        loseEmphasisOnFill: true,
                      })}
                    />
                  </div>
                  {this.linkUrl(index, item)}
                </div>
              )
            })}
            <div className="form-section block-section">
              <button onClick={this.handleBannerAdd} className="swa-add-banner">
                + Add Banner
              </button>
            </div>
            {this.pickerStartDate()}
          </div>
          <div className="form-actions">
            <CancelButton>Cancel</CancelButton>
            <SubmitButton>Save</SubmitButton>
          </div>
        </fieldset>
      </Form>
    )
  }
}

export default SWABannerLabelsForm
